import React from 'react';
import { required, DateField, SaveButton, Toolbar, FormDataConsumer, SelectInput, SimpleForm, ReferenceInput, ReferenceArrayInput,
  AutocompleteArrayInput, NumberInput, Edit, Create, BooleanInput, EditButton, Filter, List, Datagrid, NumberField, TextField,
  TextInput, BooleanField, CheckboxGroupInput, email, TabbedForm, FormTab } from 'react-admin';
import { useFormState, useForm } from 'react-final-form';

const roles = require('./components/roles.json');

const resources = [
  { id: 'networks', name: 'Networks' },
  { id: 'publishers', name: 'Publishers' },
  { id: 'sites', name: 'Sites' },
  { id: 'placements', name: 'Placements' },
  { id: 'batch', name: 'Batch Sites' },
  { id: 'batchp', name: 'Batch Placements' },
  { id: 'gam_accounts', name: 'Gam Accounts' },
  { id: 'advertisers', name: 'Advertisers' },
  { id: 'adcampaigns', name: 'Campaignes' },
  { id: 'creatives', name: 'Creatives' },
  { id: 'segments', name: 'Segments' },
  { id: 'campaigns', name: 'Traffic Rules' },
  { id: 'ad_quality_rules', name: 'Ad Quality Rules' },
  { id: 'deals', name: 'Deals' },
  { id: 'bidders', name: 'Bidders' },
  { id: 'predictions', name: 'Bid Predictions' },
  { id: 'adstxtstatus', name: 'Ads.txt' },
  { id: 'ivt', name: 'IVT Report' },
  { id: 'adcost', name: 'Request Report' },
  { id: 'topsites', name: 'Market Movers Report' },
  { id: 'realtime', name: 'Realtime Dash Report' },
  { id: 'pubreports', name: 'Earning Reports' },
  { id: 'clicks', name: 'Click Reports' },
  { id: 'auctions', name: 'Auction Reports' },
  { id: 'auction_optimizer', name: 'Auction Optimizer' },
  { id: 'discrepancies', name: 'Discrepancy Reports' },
  { id: 'adViewability', name: 'Viewability Reports' },
  { id: 'users', name: 'Users' },
  { id: 'logs', name: 'Logbook' },
  { id: 'settings', name: 'Settings' },
  { id: 'orders', name: 'Orders' },
  { id: 'line_items', name: 'Line Items' },
  { id: 'adquality_reports', name: 'Ad Quality Reports' }
];

const roleDefaultResources = (role, modifiedResources) => {
  if (modifiedResources) return modifiedResources;
  return role ? roles[role].defaultResources : [];
}

const ResourceCheckboxes = () => {
  const { values } = useFormState();
  const contextResources = () => {
    if (values.role) {
      return resources.filter(re => roles[values.role].authorizedResources.includes(re.id))
    } else {
      return []
    }
  }

  return values.role && contextResources().length > 0 ? <CheckboxGroupInput source="resources" choices={contextResources()}/> : null;
}

const RoleSelect = () => {
  const form = useForm();
  const updateCheckboxes = (e) => {
    form.change('resources', [])
  }
  return (
    <SelectInput source="role" label="Role" validate={required()} onChange={updateCheckboxes}
    choices={[
        { id: 'admin', name: 'Admin' },
        { id: 'publisher', name: 'Publisher' },
        { id: 'report_admin', name: 'Accountant' },
        { id: 'bidder', name: 'Bidder' },
        { id: 'advertiser', name: 'Advertiser' },
    ]} />
  )
}

const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_username" alwaysOn resettable />
    </Filter>
);

const CustomDateField = ({ record }) => {
    const d = (record.last_login) ? record.last_login : "Not available";
    let date = d.substring(0, d.indexOf('T'));
    let time = d.substring(d.indexOf('T') + 1, d.indexOf('.'));
    return <span><nobr>{date}</nobr><br /><nobr style={{ fontSize: 'x-small' }}>{time}</nobr></span>;
};

export const UserList = (props) => (
    <List {...props} filters={<UserFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Full name" />
            <TextField source="username" label="Username" />
            <TextField source="email" label="Email" />
            <TextField source="role" label="Role" />
            <BooleanField source="active" label="Active" />
            <CustomDateField label="Last Login" />
            <TextField source="login_count" label="Login Count" />
            <EditButton variant="contained" color="primary" />
        </Datagrid>
    </List>
);

const UserTitle = ({ record }) => {
    return <span>User {record ? `"${(record.name) ? record.name : record.username}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <span style={{ paddingLeft: '20px' }}>Last update </span><DateField source="updated_at" label="Update date" showTime style={{ paddingLeft: '10px' }} />
        <span style={{ paddingLeft: '20px' }}>Last login </span><DateField source="last_login" label="Last login date" showTime style={{ paddingLeft: '10px' }} />
        <span style={{ paddingLeft: '20px' }}>Login Count </span><NumberField source="login_count" label="Login count" style={{ paddingLeft: '10px' }} />
    </Toolbar>
);

export const UserEdit = (props) => (
    <Edit title={<UserTitle />} {...props}>
        <TabbedForm redirect={false} toolbar={<CustomToolbar /> } {...props} validateOnBlur={true}>
          <FormTab label="Settings">
            <BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />
            <TextInput source="name" label="Full name" validate={required()} />
            <TextInput source="username" label="Username" validate={required()} />
            <TextInput source="update_password" label="Password" helperText="Enter new password here if you want to update the existing password. Otherwise leave this field blank." style={{ width: '40%' }} />
            <TextInput source="email" label="Email" validate={[required(), email()]} />
            <NumberInput source='sales_commission' label='Sales Commission' helperText='Sales Commission off the PROFIT.' />
            <RoleSelect/>
            <ResourceCheckboxes/>

            {/* <ReferenceInput source="network_id" label="Network"
                reference="networks"
                perPage={10}
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                allowEmpty>
                <AutocompleteArrayInput label="Network" optionText="name" optionValue="code" style={{ width: '40%' }} />
            </ReferenceInput> */}

            <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'publisher' &&
                    <ReferenceArrayInput source="publishers" label="Publisher"
                        validate={required()}
                        reference="publishers"
                        basePath='publishers'
                        perPage={10}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                }
            </FormDataConsumer>
            <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'bidder' &&
                    <ReferenceArrayInput source="bidders" label="Bidder"
                        reference="bidders"
                        basePath='bidders'
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteArrayInput label="Bidders" optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''} optionValue="code" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                }                
            </FormDataConsumer>
            <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'advertiser' &&
                    <ReferenceArrayInput source="advertisers" label="Advertisers"
                        reference="advertisers"
                        basePath='advertisers'
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                    >
                        <AutocompleteArrayInput label="Advertisers" optionText={choice => choice && choice.name ? `${choice.name}` : ''} optionValue="code" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                }
            </FormDataConsumer>
            <hr style={{ width: '100%' }} />
            <TextField source="api_token" label="API Token" />
            <BooleanInput source="force_update_api_token" label="Force update API token" defaultValue={false} helperText="Note that updating the API token will break the APIs connecting using the existing token." style={{ width: '40%' }} />
          </FormTab>
          <FormTab label="User Preferences">
            <SelectInput source="preferences.homepage" label="Default Dashboard"
            defaultValue={null}
            choices={[
                {id:'main', name: 'Main Dashboard'},
                {id:'carbon', name: 'Analytics Dasboard'}
            ]} />
          </FormTab>
        </TabbedForm>
    </Edit>
);

export const UserCreate = (props) => (
    <Create title="Create User" {...props}>
        <SimpleForm toolbar={<CustomToolbar />} >
            <BooleanInput source="active" label="Active" validate={required()} defaultValue={true} />
            <TextInput source="name" label="Full name" validate={required()} />
            <TextInput source="username" label="Username" validate={required()} />
            <TextInput source="password" label="Password" validate={required()} />
            <TextInput source="email" label="Email" validate={[required(), email()]} />
            <BooleanInput source="notify_user" label="Send a Welcome email to user" defaultValue={true} style={{width: '17%'}}/>
            <RoleSelect/>
            <ResourceCheckboxes/>
            {/* <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'network_manager' &&
                    <ReferenceInput source="network_id" label="Network"
                        reference="networks"
                        perPage={10}
                        validate={required()}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteArrayInput label="Network" optionText="name" optionValue="code" style={{ width: '40%' }} />
                    </ReferenceInput>
                }
            </FormDataConsumer> */}
            <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'publisher' &&
                    <ReferenceArrayInput source="publishers" label="Publisher"
                        validate={required()}
                        reference="publishers"
                        basePath='publishers'
                        perPage={10}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                }
            </FormDataConsumer>
            <FormDataConsumer>
                {({ formData, ...rest }) => formData.role === 'bidder' &&
                    <ReferenceArrayInput source="bidders" label="Bidder"
                        reference="bidders"
                        basePath='bidders'
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteArrayInput label="Bidders" optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''} optionValue="code" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                }
            </FormDataConsumer>
        </SimpleForm>
    </Create >
);